import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import React, { useState } from 'react';
import { Button } from '../../components/button/button';
import { ButtonSize } from '../../core/enums';
import { ButtonVariant } from '../../core/enums';
import { Checkbox } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import { Select } from '../../components/select/select';
import './context-choice-form.scss';
import { useHistory } from 'react-router';
const ContextChoiceForm = (props)=>{
    const { contexts, handleOrganizationChoice, user } = props;
    const [selectedOrg, selectOrg] = useState(null);
    const [selectedOrgName, selectOrgName] = useState('');
    const [isDefault, setIsDefault] = useState(false);
    const history = useHistory();
    const handleDefaultCheck = (e)=>{
        setIsDefault(!isDefault);
    };
    const handleSave = (e)=>{
        if (e) {
            e.preventDefault();
            if (selectedOrg !== null) {
                handleOrganizationChoice({
                    organizationId: selectedOrg,
                    setDefault: isDefault,
                    userId: user.id || undefined
                });
            }
        }
    };
    const handleOrgSelection = (event)=>{
        const target = event.target;
        const { value, textContent } = target;
        selectOrg(+value);
        selectOrgName(textContent ?? '');
    };
    const handleBackSelection = (e)=>{
        if (e) {
            e.preventDefault();
            history.goBack();
        }
    };
    const convertContexts = (items)=>items.map((item)=>({
                value: item.organizationId,
                label: item.displayName && item.displayName !== '' ? item.displayName : item.shortDisplayName && item.shortDisplayName !== '' ? item.shortDisplayName : item.organizationCode
            }));
    return /*#__PURE__*/ _jsxs("div", {
        className: "context-choice-form form-group",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "form-row",
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "form-label",
                        children: "Where are you working today?"
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        placeholder: "Choose your organization",
                        items: convertContexts(contexts),
                        value: selectedOrgName,
                        onChange: handleOrgSelection,
                        dataTestId: "selectOrg"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "checkbox-container",
                children: [
                    /*#__PURE__*/ _jsx(Checkbox, {
                        onChange: handleDefaultCheck
                    }),
                    /*#__PURE__*/ _jsx("i", {
                        className: "form-icon"
                    }),
                    " Remember my choice"
                ]
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                className: "form-buttons",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: "Back",
                        variant: ButtonVariant.LINKS,
                        dataTestId: "back",
                        onClick: handleBackSelection
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: ButtonSize.MD,
                        label: 'Continue',
                        variant: ButtonVariant.PRIMARY,
                        disabled: selectedOrg === null,
                        name: "Continue",
                        dataTestId: "continue",
                        onClick: handleSave
                    })
                ]
            })
        ]
    });
};
export default ContextChoiceForm;
